define('views/modules/calendar/animated-session/custom-exercises-manager/form/exercise-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/external-video',
    // views
    'views/parts/form/textbox',
    'views/parts/form/textarea',
    'views/parts/modal/image-modal',
    // templates
    'text!templates/modules/calendar/animated-session/custom-exercises-manager/form/exercise-form.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    ExternalVideo,
    // views
    VTextbox,
    VTextarea,
    VImageModal,
    // templates
    TExerciseForm
) {

    var VExerciseForm = Backbone.Epoxy.View.extend({
        template: TExerciseForm,

        events: {
            'click .thumbnail-preview-container': 'onThumbnailPreviewClick'
        },

        // abstracting selectors out of the view logic
        regions: {
            root: '#exercise-form',
            name: ".name-input",
            description: ".description-input",
            url: ".url-input",
            thumbnailPreview: '.thumbnail-preview'
        },

        initialize: function() {

            this.view = {
                name: new VTextbox({ label: 'Name', attribute: 'name', labelposition: 'outer', model: this.model }),
                description: new VTextarea({ label: 'Description', attribute: 'description', labelposition: 'outer', model: this.model, rows: 2 }),
                url: new VTextbox({ label: 'calendar:Paste video hyperlink (optional)', help: 'custom-exercises-url-helptext', attribute: 'animationUrl', labelposition: 'outer', model: this.model }),
            };

            this.listenTo(this.model, 'change:animationUrl', this.onUrlChange)
                .listenTo(ExternalVideo, 'change:thumbnailUrl', this.onExternalUrlChange);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            // Assign Views
            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.name, zone.$name)
                .assign(view.description, zone.$description)
                .assign(view.url, zone.$url);

            this.applyBindings();

            this.appendTimestampToThumbnail();

            return this;
        },

        showImageModal: function() {
            var view = this.view.modal || (this.view.modal = new VImageModal({
                title: "Upload a thumbnail",
                context: this,
                callback: this.onThumbnailChange,
                cropper: {
                    aspectRatio: 1
                }
            }));
            view.show();
        },

        setThumbnailPreview: function(blob) {
            var thumbnailUrl = URL.createObjectURL(blob),
                $preview = this.zone.$thumbnailPreview;
            $preview.attr('src', thumbnailUrl);
        },

        appendTimestampToThumbnail: function() {
            this.zone.$thumbnailPreview.attr('src', this.model.get('thumbnail') + '?' + new Date().getTime());
        },

        onThumbnailPreviewClick: function() {
            this.showImageModal();
        },

        onThumbnailChange: function(confirmed, blob, view) {
            var model = this.model;
            if (confirmed && blob) {
                model.setStaticAnimation(blob);
                this.setThumbnailPreview(blob);
            }
        },

        onExternalUrlChange: function(model, value) {
            this.model.unsetStaticAnimation();
            if (this.zone) {
                this.zone.$thumbnailPreview.attr('src', value);
            }
        },

        onUrlChange: function(model, value) {
            ExternalVideo.setProviderFromUrl(value);

            if (ExternalVideo.getProvider()) {
                ExternalVideo.setVideoId();
            }
        },

    });

    return VExerciseForm;

});

